import { TAlergies } from "@/types/customerRegistration";

export const genderOptions: string[] = ["Male", "Female", "Other"];
export const allergyOptions: TAlergies[] = [
  "Egg",
  "Nuts",
  "Milk",
  "Gluten",
  "Shellfish",
  "Soy",
  "Wheat",
  "Fish",
  "Sesame",
  "Peanuts",
  "Dairy",
  "Mollusks",
  "Mustard",
  "Celery",
  "Lupin",
  "Corn",
  "Sulfites",
  "None",
];

export const isCertified: string[] = ["true", "false"];
